import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Welcome to Atelier Noir.");
      nav("/account");
    } catch (e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-24">
      <div className="overline">Create account</div>
      <h1 className="serif text-4xl mt-3">Join the maison.</h1>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <div><div className="fld-label">Name</div><input data-testid="register-name" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="fld mt-2" /></div>
        <div><div className="fld-label">Email</div><input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="fld mt-2" /></div>
        <div><div className="fld-label">Password (min 6)</div><input data-testid="register-password" type="password" minLength={6} required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="fld mt-2" /></div>
        {err && <div className="text-xs text-red-700">{err}</div>}
        <button data-testid="register-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Creating…" : "Create account"}</button>
      </form>
      <div className="text-center text-xs text-[#5A5A5A] mt-6">
        Already with us? <Link to="/login" className="text-[#0A0A0A] underline" data-testid="goto-login">Sign in</Link>
      </div>
    </div>
  );
}
